import React from "react";
import { useParams } from "react-router-dom";
import ApplicationsAdmin from "@/components/portal/ApplicationsAdmin";

const getAuthHeaders = () => {
  const token = localStorage.getItem("venka_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export default function PortalApplications() {
  const { id } = useParams();
  return (
    <div className="rounded-2xl border border-slate-800 bg-slate-900/40 text-slate-100 min-h-[80vh]" data-testid="portal-applications">
      <ApplicationsAdmin getAuthHeaders={getAuthHeaders} initialOpenId={id || null} />
    </div>
  );
}
